import React from 'react';
import i18n from '../../../../i18n';
import { makeStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { useAction, useActionDispatchOnMount } from 'core/store/store';

import { makeSignupSaveMetricsAction, makeSignupSubmitUsernameRequestAction } from 'state/signup/actions';

import { Text, TextTypography } from 'components/Text/Text';
import { TermsAndConditions } from 'components/TermsAndConditions/TermsAndConditions';

import { SignupForm as SignupReduxForm } from 'forms/SignupForm/SignupForm';

import { AuthHeader } from 'pages/Login/components/AuthHeader';

import { ReactComponent as LoginSketch } from 'assets/loginSketch.svg';

import { AlreadyRegistered } from './AlreadyRegistered';

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    contents: {
        flex: 1,
        width: 360,
        [theme.breakpoints.down(480)]: {
            width: '100%',
            padding: theme.spacing(2),
        },
    },
    footer: {
        flexGrow: 0,
        flexBasis: 'auto',
        margin: theme.spacing(2),
        marginTop: 0,
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(4),
        },
    },
    sketch: {
        marginTop: theme.spacing(7),
        [theme.breakpoints.down(361)]: {
            marginTop: theme.spacing(10),
        },
        [theme.breakpoints.down(321)]: {
            marginTop: theme.spacing(21),
        },
    },
    title: {
        [theme.breakpoints.down(360)]: {
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1),
        },
    },
    field: {
        marginBottom: theme.spacing(3),
    },
}));

export const SignupForm = () => {
    const { t } = i18n.useTranslation();
    const action = useAction();
    const history = useHistory();
    const classes = useStyles();
    const search = queryString.parse(window.location.search);
    useActionDispatchOnMount(true, makeSignupSaveMetricsAction, search?.correlationId, search?.utm_source);

    return (
        <div className={classes.container}>
            <AuthHeader onBack={() => history.goBack()} />
            <div className={classes.contents}>
                <Box m={2} textAlign="center" className={classes.sketch}>
                    <LoginSketch />
                </Box>
                <Box m={3} textAlign="center" className={classes.title}>
                    <Text typography={TextTypography.LEAD_ACCENT}>{t('auth:signup.title')}</Text>
                </Box>
                <AlreadyRegistered />
                <SignupReduxForm
                    onSubmit={data => {
                        const { username, password, captcha } = data;
                        action(makeSignupSubmitUsernameRequestAction, username, password, captcha);
                    }}
                />
            </div>
            <div className={classes.footer}>
                <TermsAndConditions buttonText={t('auth:signup.signupButton')} />
            </div>
        </div>
    );
};
